import { useSuspenseQuery } from "@tanstack/react-query";
import { favoriteBrandsQueryApi } from "@/shared/api/favorite-brands/query";
import { FavoriteBrandsResponse } from "@/shared/api/favorite-brands/types";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// 바이어의 즐겨찾기 브랜드 조회 훅 — 바이어 페이지에서는 companyId가 buyer_id다.
const useGetFavoriteBrands = () => {
  const { companyId } = useCompanyIdentity();

  const { data: favoriteBrands } = useSuspenseQuery({
    queryKey: ["favorite-brands", companyId],
    queryFn: companyId
      ? () => favoriteBrandsQueryApi.getFavoriteBrands(companyId)
      : undefined,
    select: (data) => toCamelKeyObject(data) as FavoriteBrandsResponse,
  });

  return { favoriteBrands };
};

export default useGetFavoriteBrands;
